import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import Button from '@material-ui/core/Button'
import FormGroup from '@material-ui/core/FormGroup'
import { validate, isDebug, renderField } from './helpers'
import isMobile from 'is-mobile'
import { ReviewAgreementValidation } from '../../helpers/step-builder/validations-yup'
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'

function ReviewAgreementFunc({
  // eslint-disable-next-line react/prop-types
  payload,
  // eslint-disable-next-line react/prop-types
  setPayload,
  // eslint-disable-next-line react/prop-types
  prevStep,
  // eslint-disable-next-line react/prop-types
  nextStep,
  // eslint-disable-next-line react/prop-types
  waiverContent,
  // eslint-disable-next-line react/prop-types
  waiverAgreementModel,
  // eslint-disable-next-line react/prop-types
  t
}) {
  const [errors, setErrors] = useState({})
  const hd = {
    errors,
    payload,
    setPayload,
    t
  }
  setDebugPayload()
  // eslint-disable-next-line react/prop-types
  const validation = ReviewAgreementValidation(waiverAgreementModel.optInCheck.required, t, {
    overviewQ1: waiverContent?.overviewQ1,
    overviewQ2: waiverContent?.overviewQ2,
    overviewQ3: waiverContent?.overviewQ3,
    overviewQ4: waiverContent?.overviewQ4,
    overviewQ5: waiverContent?.overviewQ5,
    overviewQ6: waiverContent?.overviewQ6
  })

  const nextStepClick = async () => {
    const _errors = await validate(validation, payload)
    if (Object.keys(_errors).length === 0) {
      nextStep()
    }
    setErrors(_errors)
  }
  const buttonFunctions = { nextStepClick, prevStep }
  return (
    <>
      <div
        style={{
          width: Math.min(600, window.innerWidth * 0.8),
          height: window.innerHeight * (isMobile() ? 0.55 : 0.7),
          overflow: 'scroll'
        }}
        className="pdf-wrapper"
      >
        <ReactMarkdown
          remarkPlugins={[gfm]}
          children={
            // eslint-disable-next-line react/prop-types
            waiverContent.waiverAgreement
          }
        />
      </div>
      <FormGroup>
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverAgreementModel.waiverAgreementCheck)
        }
        {
          // eslint-disable-next-line react/prop-types
          renderField(hd, waiverAgreementModel.optInCheck)
        }

        <div className="left mt-1" dangerouslySetInnerHTML={{ __html: t('privacyNotice') }} />
      </FormGroup>
      <fieldset className="mt-1" id="overviewQuestions">
        <legend className="ph-1 pv-1" style={{ fontSize: '0.8em' }}>
          {t('overviewQuestions')}
        </legend>
        <FormGroup className="p-0 up-2 pb-1">
          {waiverContent?.overviewQ1
            ? // eslint-disable-next-line react/prop-types
              renderField(hd, waiverAgreementModel.overviewQ1Check, waiverContent)
            : null}
          {waiverContent?.overviewQ2
            ? // eslint-disable-next-line react/prop-types
              renderField(hd, waiverAgreementModel.overviewQ2Check, waiverContent)
            : null}
          {waiverContent?.overviewQ3
            ? // eslint-disable-next-line react/prop-types
              renderField(hd, waiverAgreementModel.overviewQ3Check, waiverContent)
            : null}
          {waiverContent?.overviewQ4
            ? // eslint-disable-next-line react/prop-types
              renderField(hd, waiverAgreementModel.overviewQ4Check, waiverContent)
            : null}
          {waiverContent?.overviewQ5
            ? // eslint-disable-next-line react/prop-types
              renderField(hd, waiverAgreementModel.overviewQ5Check, waiverContent)
            : null}
          {waiverContent?.overviewQ6
            ? // eslint-disable-next-line react/prop-types
              renderField(hd, waiverAgreementModel.overviewQ6Check, waiverContent)
            : null}
        </FormGroup>
      </fieldset>

      <div className="right">
        {waiverAgreementModel &&
          // eslint-disable-next-line react/prop-types
          waiverAgreementModel.buttons.map((button, ix) => (
            <Button
              variant={button.variant}
              color={button.color}
              size={button.size}
              className={button.className}
              onClick={buttonFunctions[button.clickFunc]}
              id={
                // eslint-disable-next-line react/prop-types
                waiverAgreementModel.label + '-' + button.label + '-' + ix.toString()
              }
              key={
                // eslint-disable-next-line react/prop-types
                waiverAgreementModel.label + '-' + button.label + '-' + ix.toString()
              }
            >
              {t(button.label)}
            </Button>
          ))}
      </div>
    </>
  )

  function setDebugPayload() {
    if (isDebug() && Object.keys(payload).length < 2) {
      setPayload({
        promotionalEmailPromptRequired: true,
        waiverAgreementCheck: true,
        optInCheck: true,
        overviewQ1Check: true,
        overviewQ2Check: true,
        overviewQ3Check: true,
        overviewQ4Check: true,
        overviewQ5Check: true,
        overviewQ6Check: true
      })
    }
  }
}

export const ReviewAgreement = withTranslation()(ReviewAgreementFunc)
